import React from "react";
import { PACKAGING_TYPES } from "../../data/packaging";

// Resolve illustrations from the registry, never from product gallery data.
// Unknown or malformed entries are omitted; the coverage check catches omissions.
export function resolvePackagingOption(option) {
  if (!option || typeof option.id !== "string" || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(option.id)
    || !["single", "text", "combination"].includes(option.type) || !Array.isArray(option.items)) return null;
  const keys = option.items.map(item => typeof item === "string" ? item : item?.key);
  if (keys.some(key => !Object.prototype.hasOwnProperty.call(PACKAGING_TYPES, key))
    || new Set(keys).size !== keys.length) return null;
  const items = keys.map(key => ({ ...PACKAGING_TYPES[key], key }));
  if (option.type === "combination") {
    if (items.length !== 2 || items.some(item => !item.image)) return null;
  } else if (items.length !== 1 || (option.type === "text") !== (items[0].image === null)) return null;
  return { id: option.id, type: option.type, items, name: items.map(item => item.label).join(" + ") };
}

function PackagingIllustration({ item }) {
  // Small packaging icons should be ready with the card, including the final
  // unique image in a combination list, instead of waiting for lazy loading.
  return <img className="pds-packaging-illustration" src={item.image} alt="" aria-hidden="true"
    width={item.width} height={item.height} loading="eager" decoding="sync" />;
}

export function PackagingOptionCard({ option }) {
  return <li className={`pds-packaging-card pds-packaging-card--${option.type}`}
    data-option-id={option.id} data-option-type={option.type}>
    {option.type !== "text" && <div className="pds-packaging-art" aria-hidden="true">
      {option.items.map((item, index) => <React.Fragment key={item.key}>
        {index > 0 && <span className="pds-packaging-plus" aria-hidden="true">+</span>}
        <PackagingIllustration item={item} />
      </React.Fragment>)}
    </div>}
    <h3>{option.name}</h3>
  </li>;
}

export default function PackagingOptions({ options }) {
  return (
    // eslint-disable-next-line jsx-a11y/no-redundant-roles -- Preserve list semantics in Safari when list-style is none.
    <ul className="pds-packaging-grid" role="list" aria-label="Available packaging formats">
      {options.map(option => <PackagingOptionCard key={option.id} option={option} />)}
    </ul>
  );
}
